module.exports = __webpack_public_path__ + "static/media/maleCute.7fdb3e7b.png";